import React from "react";

const SidebarHeader = ({ isDarkMode, edgeServerEndpoint }) => {

  return (
    <div className="px-6 py-4 bg-inherit">
      <div className="flex items-center justify-between ">
        <div className="flex flex-col">
          <h3 className={`text-lg font-semibold ${isDarkMode ? "text-white" : "text-gray-800"}`}>
            Boondock Edge
          </h3>
          <p className={`text-xs ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
            Boondock Technologies
          </p>
        </div>
      </div>
    </div>
  );
};

export default SidebarHeader;